import { mapMutations, mapState } from "vuex";

export const editMixin = {
  watch: {
    "ruleForm.contractScale"(value) {
      if (/\d+\.\d{3,}$/g.test("" + value)) {
        this.ruleForm.contractScale = Number(value).toFixed(2);
      }
    }
  }
};
